'use es6';

import React from 'react';
import PropTypes from 'prop-types';
import { sourceKeys } from '../../data/upgradeData/properties/sources';
import UIDialogHeaderImage from 'UIComponents/dialog/UIDialogHeaderImage';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import H2 from 'UIComponents/elements/headings/H2';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIList from 'UIComponents/list/UIList';
import UIButton from 'UIComponents/button/UIButton';
import { WEB_FONT_DEMI_BOLD_WEIGHT } from 'HubStyleTokens/misc';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { upgradeDataPropsInterface } from '../../data/upgradeData/interfaces/upgradeDataPropsInterface';
import { openNewTab } from 'ui-addon-upgrades/_core/common/navigation/url';
import { getAcademyTrialRedirectLink } from '../../../trial/utils';
import { StyledModal } from '../StyledModal';
var TRIAL = sourceKeys.TRIAL;

var ActivationSuccessModal = function ActivationSuccessModal(_ref) {
  var ctaText = _ref.ctaText,
      hideBackground = _ref.hideBackground,
      header = _ref.header,
      onSuccess = _ref.onSuccess,
      showIllustration = _ref.showIllustration,
      subText = _ref.subText,
      type = _ref.type,
      showTrialLoadingState = _ref.showTrialLoadingState,
      showSubtitle = _ref.showSubtitle,
      _ref$upgradeData = _ref.upgradeData,
      app = _ref$upgradeData.app,
      upgradeProduct = _ref$upgradeData.upgradeProduct;
  var isTrialModal = type === TRIAL;
  var academySuccessButtonProps = app === 'learning-center' ? {
    external: true,
    href: getAcademyTrialRedirectLink(upgradeProduct) // href is required only for the external icon to show up

  } : undefined;

  var onSuccessHandler = function onSuccessHandler() {
    if (app === 'learning-center') {
      openNewTab(getAcademyTrialRedirectLink(upgradeProduct));
    }

    onSuccess();
  };

  return React.createElement(StyledModal, {
    hideBackground: hideBackground,
    centered: true,
    size: "auto",
    use: "success",
    width: 600
  }, showIllustration && React.createElement(UIDialogHeaderImage, {
    offsetBottom: -30,
    offsetTop: 40
  }, React.createElement(UIIllustration, {
    name: "success",
    width: 118
  })), React.createElement(UIDialogHeader, {
    className: showSubtitle ? 'p-bottom-2' : undefined
  }, React.createElement("div", null, React.createElement(H2, null, header || React.createElement(FormattedMessage, {
    message: "upgrades.activationModal." + (isTrialModal ? 'trialTitle' : 'productTitle')
  })), showSubtitle && React.createElement("span", null, React.createElement("p", {
    className: "m-top-4 m-bottom-2"
  }, React.createElement(FormattedMessage, {
    message: "upgrades.activationModal.trialSubtitle"
  })), React.createElement("p", {
    className: "text-center",
    style: {
      fontWeight: WEB_FONT_DEMI_BOLD_WEIGHT
    }
  }, React.createElement(FormattedMessage, {
    message: "upgrades.products." + upgradeProduct
  }))))), subText && React.createElement(UIDialogBody, null, React.createElement("p", null, subText)), React.createElement(UIDialogFooter, {
    align: "center"
  }, React.createElement(UIList, {
    firstChildClassName: "m-bottom-3",
    style: {
      maxWidth: '350px'
    }
  }, showTrialLoadingState ? React.createElement(UILoadingSpinner, {
    style: {
      marginLeft: '90px'
    },
    showLabel: true,
    label: React.createElement(FormattedMessage, {
      message: "upgrades.activationModal.loadingLabel"
    })
  }) : React.createElement(UIButton, Object.assign({
    block: true,
    use: "primary",
    onClick: onSuccessHandler
  }, academySuccessButtonProps), ctaText || React.createElement(FormattedMessage, {
    message: "upgrades.activationModal.getStarted"
  })))));
};

ActivationSuccessModal.defaultProps = {
  showIllustration: true,
  showSubtitle: false,
  showTrialLoadingState: false
};
ActivationSuccessModal.propTypes = Object.assign({
  ctaText: PropTypes.node,
  hideBackground: PropTypes.bool,
  header: PropTypes.node,
  onSuccess: PropTypes.func,
  showIllustration: PropTypes.bool,
  subText: PropTypes.node,
  type: PropTypes.string.isRequired,
  showTrialLoadingState: PropTypes.bool,
  showSubtitle: PropTypes.bool
}, upgradeDataPropsInterface);
export default ActivationSuccessModal;